import { render, staticRenderFns } from "./preferences.vue?vue&type=template&id=5460fa24&scoped=true&"
import script from "./preferences.vue?vue&type=script&lang=ts&"
export * from "./preferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460fa24",
  null
  
)

export default component.exports